import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { loginPath, captureReturnTo, withReturnTo } from '@/lib/returnTo';

const COMPLETE_PROFILE_PATH = '/complete-profile';

export function ProtectedRoute() {
  const { loading, isAuthenticated, needsProfileCompletion } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={loginPath(location)} replace />;
  }

  // Push users with an incomplete profile to /complete-profile — but never
  // redirect that page to itself, or the guard loops forever and the page
  // renders blank (happens right after a Google sign-up, where the profile
  // still needs gender/age).
  if (needsProfileCompletion && location.pathname !== COMPLETE_PROFILE_PATH) {
    return (
      <Navigate to={withReturnTo(COMPLETE_PROFILE_PATH, captureReturnTo(location))} replace />
    );
  }

  return <Outlet />;
}
